export default "__VITE_ASSET__DJVI5s$9__"